// Shapes that mirror the API contracts in
// Levitate-API/docs/api/meta-managed-ads.md.

export interface IMetaGlobalConnectionStatus {
	checkedAt: string;
	tokenConfigured: boolean;
	verificationSucceeded: boolean;
	systemUserId?: string;
	systemUserName?: string;
	error?: string;
}

interface ILevitateAccountRef {
	id: string;
	// The API may not have a display name for an account (e.g. internal/demo accounts).
	name: string | null;
}

export interface IMetaVisibleAsset {
	metaAdAccountId: string;
	name: string;
	accountStatus: number;
	businessName: string;
	isClientAccount: boolean;
	ownedByLevitateAccounts: ILevitateAccountRef[];
	managedByLevitateAccounts: ILevitateAccountRef[];
	unmapped: boolean;
}

// Records a sweep failure on the connection projection. `metaAdAccountId` is
// empty when the failure was at the connection level (e.g. token unavailable).
export interface IMetaMetricsSyncError {
	metaAdAccountId: string;
	timestamp: string;
	message: string;
}

// Shape returned by `GET admin/ads/meta/connections/{levitateAccountId}` and
// (partially) by the assign/unassign mutations. Mutation responses only set the
// first three fields; the optional metadata fields require the GET endpoint.
export interface IMetaConnectionState {
	levitateAccountId: string;
	managedAdAccountIds: string[];
	hasCustomerToken: boolean;
	// Customer-OAuth-selected ad accounts. Only present on GET responses.
	adAccountIds?: string[];
	// Observability metadata written by the daily metrics sweep. Present only on
	// GET responses once the API team surfaces the connection projection.
	lastMetricsSyncAt?: string;
	lastMetricsSyncError?: IMetaMetricsSyncError;
}

export interface IAssignManagedRequest {
	levitateAccountId: string;
	metaAdAccountIds: string[];
}

export interface IUnassignManagedRequest {
	levitateAccountId: string;
	metaAdAccountId: string;
}

export const META_AD_ACCOUNT_STATUS_LABELS: Record<
	number,
	{ label: string; tone: 'success' | 'warning' | 'danger' | 'neutral' }
> = {
	1: { label: 'Active', tone: 'success' },
	2: { label: 'Disabled', tone: 'warning' },
	3: { label: 'Unsettled', tone: 'warning' },
	7: { label: 'Pending risk review', tone: 'warning' },
	8: { label: 'Pending settlement', tone: 'warning' },
	9: { label: 'In grace period', tone: 'warning' },
	100: { label: 'Pending closure', tone: 'danger' },
	101: { label: 'Closed', tone: 'danger' },
	201: { label: 'Any active', tone: 'success' },
	202: { label: 'Any closed', tone: 'danger' },
};
